import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { GRVValidationActionTypes } from "./GRVValidation.type";
import { formatQuery } from "../Utils";

export function* fetchAllGRVValidations(action: any): any {
    try {
        const response = yield axios.get(`${API_BASE_URI}/grv-validation?${formatQuery(action)}`);
        yield put({
            type: GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION_FAILURE,
            payload: error,
        });
    }
}

export function* fetchOneGRVValidations(action: any): any {
    try {
        const response = yield axios.get(
            `${API_BASE_URI}/grv-validation/${action.payload}`
        );
        yield put({
            type: GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION_FAILURE,
            payload: error,
        });
    }
}

export function* fetchPagedGRVValidations(action: any): any {
    try {
        const response = yield axios.get(
            `${API_BASE_URI}/grv-validation/paged?${formatQuery(action)}`
        );
        yield put({
            type: GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION_FAILURE,
            payload: error,
        });
    }
}

export function* watcherFetchAllGRVValidations() {
    yield takeLatest(GRVValidationActionTypes.FETCH_ALL_GRV_VALIDATION, fetchAllGRVValidations);
}

export function* watcherFetchOneGRVValidations() {
    yield takeLatest(GRVValidationActionTypes.FETCH_ONE_GRV_VALIDATION, fetchOneGRVValidations);
}

export function* watcherFetchPagedGRVValidations() {
    yield takeLatest(
        GRVValidationActionTypes.FETCH_PAGED_GRV_VALIDATION,
        fetchPagedGRVValidations
    );
}
